import { TrackingManagerState } from "./TrackingManagerState";
import {
	TrackedEventData,
	InternalEventData,
	GaEventData,
} from "../types/EventsData";
import { AnalyticsTracker } from "../trackers/AnalyticsTracker";
import { ContractSectionsTracker } from "../trackers/ContractSectionsTracker";

/**
 * This class represents a state when the TrackingManager has been fully initialized.
 */
export class InitializedTrackingManager extends TrackingManagerState {
	constructor(
		private readonly googleAnalyticsTracker: AnalyticsTracker<GaEventData>,
		private readonly bingAnalyticsTracker: AnalyticsTracker<undefined>,
		private readonly internalAnalyticsTracker: AnalyticsTracker<InternalEventData>,
		private readonly contractSectionsTracker: ContractSectionsTracker
	) {
		super();
	}

	initialize(): Promise<void> {
		this.updateTrackersExecutionContext();
		this.googleAnalyticsTracker.submitPageView();
		this.bingAnalyticsTracker.submitPageView();
		this.internalAnalyticsTracker.submitPageView();
		return Promise.resolve();
	}

	submitGAEvent(eventData: GaEventData): void {
		this.googleAnalyticsTracker.submitEvent(eventData);
	}

	submitInternalEvent(eventData: InternalEventData): void {
		this.internalAnalyticsTracker.submitEvent(eventData);
	}

	submitTrackedEvent(eventData: TrackedEventData): void {
		this.submitGAEvent(eventData.createGaEventData());
		this.submitInternalEvent(eventData.createInternalEventData());
	}

	trackSignedEvent(webuserDataId: string): void {
		const trackedEventData = new TrackedEventData();
		trackedEventData.action = "signed";
		trackedEventData.component = webuserDataId;
		trackedEventData.section = "esignature";
		this.submitTrackedEvent(trackedEventData);
	}

	trackSharingEvent(webuserDataId: string): void {
		const trackedEventData = new TrackedEventData();
		trackedEventData.action = "share";
		trackedEventData.component = webuserDataId;
		trackedEventData.section = "sharing";
		this.submitTrackedEvent(trackedEventData);
	}

	trackContractSection(newSection: string, newGroup: string): void {
		this.contractSectionsTracker.track(newSection, newGroup);
	}

	private updateTrackersExecutionContext() {
		this.googleAnalyticsTracker.executionContext = this.executionContext;
		this.internalAnalyticsTracker.executionContext = this.executionContext;
		this.bingAnalyticsTracker.executionContext = this.executionContext;
		this.contractSectionsTracker.executionContext = this.executionContext;
	}
}
